import React from 'react';
import { Phone, Video, X } from 'lucide-react';

interface Props {
  name: string;
  avatarUrl?: string | null;
  channelName?: string | null;
  isVideo?: boolean;
  onOpen: () => void;
  onDismiss: () => void;
  onMute?: () => void;
}

const IncomingCallToast: React.FC<Props> = ({ name, avatarUrl, channelName, isVideo, onOpen, onDismiss, onMute }) => {
  const [muted, setMuted] = React.useState(false);
  const initials = name.split(' ').filter(Boolean).slice(0, 2).map((p) => p[0]).join('').toUpperCase();
  const Icon = isVideo ? Video : Phone;
  return (
    <div className="w-[360px] max-w-[calc(100vw-2rem)] rounded-xl border border-border bg-card text-card-foreground shadow-2xl overflow-hidden">
      <div className="h-1 bg-success animate-pulse" />
      <div className="flex items-center gap-3 p-4">
        <div className="relative shrink-0">
          <span className="absolute inset-0 rounded-full bg-success/40 animate-ping" />
          {avatarUrl ? (
            <img src={avatarUrl} alt={name} className="relative h-12 w-12 rounded-full object-cover border-2 border-success" />
          ) : (
            <div className="relative h-12 w-12 rounded-full bg-muted border-2 border-success flex items-center justify-center text-sm font-semibold text-foreground">
              {initials || <Icon className="h-5 w-5" />}
            </div>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-medium text-success flex items-center gap-1">
            <Icon className="h-3.5 w-3.5" /> Chamada de {isVideo ? 'vídeo' : 'voz'} recebida
          </p>
          <p className="truncate text-base font-semibold text-foreground">{name}</p>
          <p className="truncate text-xs text-muted-foreground">
            WhatsApp{channelName ? ` · ${channelName}` : ''}
          </p>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dispensar"
          className="self-start rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="flex gap-2 px-4 pb-4">
        <button
          type="button"
          onClick={() => {
            if (onMute) {
              onMute();
              setMuted(true);
            } else {
              onDismiss();
            }
          }}
          disabled={muted}
          className="flex-1 h-9 disabled:opacity-60 rounded-md border border-border bg-muted text-sm font-medium text-foreground hover:bg-muted/70"
        >
          {muted ? 'Silenciado' : 'Silenciar'}
        </button>
        <button
          type="button"
          onClick={onOpen}
          className="flex-1 h-9 rounded-md bg-success text-success-foreground text-sm font-semibold hover:opacity-90 flex items-center justify-center gap-1.5"
        >
          <Phone className="h-4 w-4" /> Abrir conversa
        </button>
      </div>
    </div>
  );
};

export default IncomingCallToast;
